import { render, staticRenderFns } from "./SubpageNotificationContacts.vue?vue&type=template&id=47800374&scoped=true&"
import script from "./SubpageNotificationContacts.vue?vue&type=script&lang=js&"
export * from "./SubpageNotificationContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47800374",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47800374')) {
      api.createRecord('47800374', component.options)
    } else {
      api.reload('47800374', component.options)
    }
    module.hot.accept("./SubpageNotificationContacts.vue?vue&type=template&id=47800374&scoped=true&", function () {
      api.rerender('47800374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/notifications/SubpageNotificationContacts.vue"
export default component.exports